<template>
  <wh-popup
    v-model="myVisible"
    title="原料追溯"
    :ref-form="$refs.RawPopup"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="RawPopup"
      class="raw-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="row-list">
        <van-cell v-for="item in form.rawMaterialsInfo||[]" :key="item.id" class="raw-item">
          <template #title>
            <van-checkbox v-model="item.flag" />
          </template>
          <div class="content">
            <div class="wh-flex-between">
              <span>{{ item.materialName }}</span>
              <span>{{ formatTime(item.warehousingTime,'YYYY-MM-DD') }}</span>
            </div>
            <div class="wh-flex-between">
              <span>{{ item.stockType }}</span>
              <span>{{ item.staffName }}</span>
            </div>
          </div>
          <template v-if="item.traceCode" #right-icon>
            <van-icon name="edit" class="edit-icon" @click="handleClickEdit(item.traceCode)" />
          </template>
        </van-cell>
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import { formatTime } from '@/utils/convert/convertTime'
export default {
  components: { WhPopup },
  mixins: [formPopup],
  data() {
    return {
      form: {
        rawMaterialsInfo: []
      }
    }
  },
  methods: {
    formatTime,
    open() {
      this.formDataInit(this.form, this.initFormData)
      this.form.rawMaterialsInfo.map(i => {
        if (!i.hasOwnProperty('flag')) {
          this.$set(i, 'flag', false)
        }
      })
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.hidePopup()
    },
    handleClickEdit(code) {
      this.$router.push({ name: 'TraceSource', query: { traceCode: code }})
    }
  }
}
</script>
<style lang="less" scoped>
.raw-popup{
   padding: 10px 16px;
   .row-list{
   }
   .raw-item{
     background-color: #F5F7FA;
     border-radius: 8px;
     margin-bottom: 10px;
     .content{
       padding: 0 4px;
     }
     .van-cell__title {
       align-self: center;
       flex-grow: 0;
       flex-shrink: 0;
     }
     .edit-icon {
       font-size: 20px;
       flex-shrink: 0;
       align-self: center;
       color: @primary-color;
     }
   }
}
</style>
